import debounce from '../helpers/debounce';

const SCROLL_THRESHOLD = 50;
const DEBOUNCE_DELAY = 10;

export default class MainHeader {
  constructor(section) {
    this.section = section;

    this.section.el.className += ' sticky top-0 z-50 h-10';

    // Add direct scroll listener for position-based logo switching
    this.handleScroll = debounce(this.updateLogoVisibility, DEBOUNCE_DELAY);
    window.addEventListener('scroll', this.handleScroll, { passive: true });

    // Set initial state
    this.updateLogoVisibility();
  }

  updateLogoVisibility = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const isNearTop = scrollTop < SCROLL_THRESHOLD;

    if (isNearTop) {
      this.section.el.classList.remove('header--scrolled');
    } else {
      this.section.el.classList.add('header--scrolled');
    }
  };

  onSectionUnload() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
